var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "CommentSettings" } }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "mode-card" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _vm._v(_vm._s(_vm.$t("message.ticket")) + "\n                "),
            _c("a-switch", {
              staticClass: "md-warning ml-3",
              attrs: { "checked-children": "✔", "un-checked-children": "✖" },
              on: { change: _vm.handleTicketModeChange },
              model: {
                value: _vm.ticketMode,
                callback: function ($$v) {
                  _vm.ticketMode = $$v
                },
                expression: "ticketMode",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("instagram.commentSettingsTicket"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "mode-card" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _vm._v(_vm._s(_vm.$t("chatbotv2.chatbot")) + "\n                "),
            _c("a-switch", {
              staticClass: "md-warning ml-3",
              attrs: { "checked-children": "✔", "un-checked-children": "✖" },
              on: { change: _vm.handleChatbotModeChange },
              model: {
                value: _vm.chatbotMode,
                callback: function ($$v) {
                  _vm.chatbotMode = $$v
                },
                expression: "chatbotMode",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("instagram.commentSettingsChatbot"))),
        ]),
        _vm._v(" "),
        _vm.chatbotMode
          ? _c(
              "div",
              [
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%", "margin-top": "10px" },
                    attrs: {
                      defaultValue: null,
                      notFoundContent: _vm.$t(
                        "search.integration.forwardLiveAgents"
                      ),
                    },
                    model: {
                      value: _vm.channel.commentForward.story,
                      callback: function ($$v) {
                        _vm.$set(_vm.channel.commentForward, "story", $$v)
                      },
                      expression: "channel.commentForward.story",
                    },
                  },
                  _vm._l(_vm.stories, function (story) {
                    return _c(
                      "a-select-option",
                      { key: story._id, attrs: { value: story._id } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(story.title) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }